import React from 'react';
import AddHeader from '../../../../components/layout/header/add';
import Form from '../../../../components/molecules/forms';
import {
  Delete, LineStroke, Pencil,
} from '../../../../components/atoms/icons';
import {
  SERVICE_PRIORITY_OPTIONS,
  SERVICE_REASON_OPTIONS,
  SERVICE_STATUS_OPTIONS,
} from '../../../../components/atoms/const';
import Button from '../../../../components/molecules/buttons';
import AddServiceIcon from '../../../../assets/icons/add-service.png';
import FormFooter from '../../../../components/layout/footer/form';
import useEditService from './hooks';

function EditService() {
  const {
    formik,
    invoices,
    navigateToInvoices,
    navigateToLanding,
    updateServiceLoad,
    driverList,
    navigateToViewInvoice,
  } = useEditService();
  const getTotal = (data: any) => {
    const b = data?.billAmount || 0;
    if (data?.parts?.length > 0) {
      const c = data?.parts?.map((x: any) => x?.split(':')?.[1]?.trim()).reduce((sum: any, total: number) => Number(sum) + Number(total), 0);
      return b + c;
    }
    return b;
  };

  return (
    <div>
      <div className="position-relative">
        <AddHeader
          primary={{ route: '/customer-support', title: 'Service Request' }}
          title="Edit Service Request"
          topRightItem={(
            <button
              type="button"
              onClick={navigateToInvoices}
              className="border-0 bg-transparent"
            >
              <img
                src={AddServiceIcon}
                alt="addServiceIcon"
                width={26}
                style={{ marginBottom: '4px' }}
              />
            </button>
          )}
        />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div>
          <div className="px-4 px-xl-5">
            <div className="fw-bold fz-16 mb-4">Invoice</div>
            {invoices?.map((invoice: { description: string, billAmount: number, parts: any }) => (
              <div className="w-100 d-flex align-items-center px-4 py-3 mt-2" style={{ backgroundColor: '#F3F4F8', borderRadius: '20px' }}>
                <div className="fz-14 flex-grow-1">
                  <div className="fw-bold">{invoice?.description}</div>
                  <div>{`$${getTotal(invoice)}`}</div>
                </div>
                <div className="d-flex align-items-center gap-xl-5 gap-4">
                  <div style={{ width: '150px' }}>
                    <Button.Default
                      id="viewInvoice"
                      type="button"
                      label="View Invoice"
                      size="md"
                      outline
                      onClick={() => {
                        sessionStorage.setItem('clientName', formik.values.clientName ?? '');
                        sessionStorage.setItem('invoice', JSON.stringify(invoice));
                        navigateToViewInvoice();
                      }}
                      style={{ backgroundColor: 'transparent' }}
                    />
                  </div>
                  <div>
                    <Pencil color="black" />
                  </div>
                  <div>
                    <Delete color="black" />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="bg-stroke my-4" style={{ height: '7px' }} />
        </div>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Client Info</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="ticketNumber"
                placeholder="Enter Ticket Number"
                label="Ticket Number"
                readOnly
                value={formik.values.id}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="clientName"
                placeholder="Enter Client Name"
                label="Client Name"
                readOnly
                value={formik.values.clientName ?? ''}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="vmId"
                placeholder="Enter Machine ID"
                label="Machine ID"
                readOnly
                value={formik.values.vmId ?? ''}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactDatePicker
                id="requestDate"
                selectedDate={formik.values.requestDate ? new Date(formik.values.requestDate) : null}
                handleChange={(e) => {
                  if (e) {
                    formik.setFieldValue('requestDate', e);
                  }
                }}
                placeholder="Choose Request Date"
                label="Request Date"
                disabled={Boolean(true)}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="reason"
                placeholder="Enter Service Reason"
                value={SERVICE_REASON_OPTIONS.find((x) => x.value === formik.values.serviceReason ?? '') ?? null}
                label="Service Reason"
                options={SERVICE_REASON_OPTIONS}
                isSearchable={false}
                disabled={Boolean(true)}
              />
            </div>
          </div>
        </div>
        <div className="bg-stroke my-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Service Info</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="priority"
                placeholder="Choose Priority"
                isSearchable={false}
                label="Priority"
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('priority', e?.value);
                  }
                }}
                value={SERVICE_PRIORITY_OPTIONS.find((x) => x.value === formik.values.priority ?? '') ?? null}
                options={SERVICE_PRIORITY_OPTIONS}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="serviceStatus"
                placeholder="Choose Status"
                isSearchable={false}
                label="Status"
                onChange={(e) => {
                  if (e) {
                    console.log(e);
                    formik.setFieldValue('serviceStatus', e?.value);
                  }
                }}
                value={SERVICE_STATUS_OPTIONS.find((x) => x.value === formik.values.serviceStatus ?? '') ?? null}
                options={SERVICE_STATUS_OPTIONS.filter((x) => x.value !== null)}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="userId"
                label="Technician"
                onChange={(e) => {
                  if (e) {
                    console.log(e);
                    formik.setFieldValue('userId', e?.value);
                  }
                }}
                value={driverList()?.find((x: any) => x.value === formik.values.userId ?? '') ?? null}
                options={driverList() ?? []}
                placeholder="Technician Name"
              />
            </div>
            {/* eslint-disable */}
            {
              formik.values.serviceStatus === 2
                ? <div className="col-lg-4 mb-4">
                  <Form.ReactDatePicker
                    id="scheduleDate"
                    selectedDate={formik.values.scheduleDate ? new Date(formik.values.scheduleDate) : null}
                    handleChange={(e) => {
                      if (e) {
                        formik.setFieldValue('scheduleDate', e);
                      }
                    }}
                    placeholder="Choose Schedule Date"
                    label="Schedule Date"
                  />
                </div>
                : null
            }
          </div>
        </div>
        <LineStroke height={7} />
        <div className="d-flex justify-content-end p-4 px-xl-5">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              onClick={navigateToLanding}
              outline
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="submit"
              type="submit"
              label="Save"
              size="lg"
              loading={updateServiceLoad}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditService;
